import { Icon } from '@zillow/constellation-10';
import { IconErrorFilled } from '@zillow/constellation-icons';

type Props = {
  title?: string;
  tabIndex?: number;
  marginRight?: string;
};

const AccordionIconError = ({ title = 'Error', ...rest }: Props) => {
  return (
    <Icon
      size="sm"
      css={{ color: 'icon.feedback.warning.strong' }}
      render={<IconErrorFilled />}
      data-testid="AccordionIconError"
      {...rest}
    >
      <title>{title}</title>
    </Icon>
  );
};

export default AccordionIconError;
